<template>
  <div class="videoDescription">
    <div class="description">
      <div class="title">Description</div>
      <div class="text">
        {{additionals.description_for_video}}
      </div>
    </div>
    <div class="timecodes">
      <div class="timecode" v-for="(timecode, index) in additionals.timecodes" :key="index">
        <div class="time" @click="$emit('selectTime', getSeconds(timecode.timecode_with_title.time))">
          {{ timecode.timecode_with_title.time.minutes }}:{{ pad(timecode.timecode_with_title.time.seconds, 2) }}
        </div>
        <div class="title">{{timecode.timecode_with_title.title}}</div>
        <div class="like" @click.stop="$emit('likeVideoPart', index)">
          <IconLike :liked="timecode.timecode_with_title.liked"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconLike from "@/components/market/icons/IconLike";

export default {
  name: "VideoDescription",
  props: {
    additionals: Object,
  },
  components: {
    IconLike
  },
  methods: {
    pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    },
    getSeconds(time) {
      return +time.minutes * 60 + +time.seconds;
    },
  }
}
</script>

<style lang="scss" scoped>
.videoDescription {
  padding-left: 30px;
  margin-right: 1px;
  background-color: #fff;
  padding-bottom: 50px;
  .description {
    .title {
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      text-transform: uppercase;
      color: #3B3B3B;
      padding-top: 33px;
      margin-bottom: 15px;
    }
    .text {
      color: #919090;
      font-size: 16px;
      line-height: 1.3;
      margin-bottom: 30px;
    }
  }
  .timecodes {
    .timecode {
      display: flex;
      .time {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #9EC360;
        cursor: pointer;
        margin-right: 5px;
      }
      .title {
        color: #919090;
      }
      .like {
        margin-left: 10px;
      }
    }
  }
}
</style>